<template>
  <div class="mod-config">
    <el-form
      :inline="true"
      :model="dataForm"
      @keyup.enter.native="getDataList()"
    >
      <el-form-item label="">
        <el-input
          v-model="dataForm.stageName"
          placeholder="阶段名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-dict-select
          placeholder="所属系列"
          v-model="dataForm.itemId"
          type="courseItemSelects"
          :props="{ value: 'id', label: 'itemName' }"
        ></el-dict-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="rgetDataList()">查询</el-button>
        <el-button
          v-if="isAuth('course:stage:save')"
          type="primary"
          @click="addOrUpdateHandle()"
          >新增</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      style="width: 100%"
    >
      <el-table-column
              type="index"
              header-align="center"
              align="center"
              label="序号"
              :index="indexMethod"
              width="50" >
      </el-table-column>
      <el-table-column
        prop="stageName"
        header-align="center"
        align="center"
        label="阶段名称"
      >
      </el-table-column>
      <el-table-column
        prop="itemName"
        header-align="center"
        align="center"
        label="所属系列"
      >
      </el-table-column>
      <!--     <el-table-column
        prop="orgName"
        header-align="center"
        align="center"
        label="所属机构">
      </el-table-column>-->
      <el-table-column
        prop="courseNum"
        header-align="center"
        align="center"
        label="课程数量"
      >
      </el-table-column>
      <el-table-column
        prop="createName"
        header-align="center"
        align="center"
        label="创建人"
      >
      </el-table-column>
      <el-table-column
        prop="sort"
        header-align="center"
        align="center"
        label="排序"
      >
        <template #default="{ row }">
          <div v-if="!row.sortFlag" @click="onClickRow(row)">
            {{ row.sort }}
          </div>
          <div v-else>
            <el-input v-model="row.sort" @blur="onSortBlur(row)"></el-input>
          </div>
        </template>
      </el-table-column>

      <el-table-column
              prop="createTime"
              header-align="center"
              align="center"
              v-if="manageOrgIdFlag()"
              label="创建时间"
      >
      </el-table-column>

      <el-table-column
              prop="updateTime"
              header-align="center"
              align="center"
              v-if="manageOrgIdFlag()"
              label="修改时间"
      >
      </el-table-column>
      <el-table-column

        header-align="center"
        align="center"
        width="150"
        label="操作"
      >
        <template slot-scope="{ row }">
          <el-button
            v-if="isAuth('course:stage:update')"
            type="text"
            size="small"
            @click="addOrUpdateHandle(row.id)"
            >修改</el-button
          >
          <el-button
            v-if="isAuth('course:stage:delete')"
            type="text"
            size="small"
            @click="deleteHandle(row)" style="color:#F56E6E"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @refreshDataList="getDataList"
    ></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from "./stage-add-or-update";

export default {
  data() {
    return {
      dataForm: {
        stageName: "",
        itemId: "",
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
    };
  },
  components: {
    AddOrUpdate,
  },
  created() {
    this.getDataList();
    this.doSearch();
  },
  methods: {
    indexMethod(index) {
      return (this.pageIndex-1) * this.pageSize + index + 1;
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      this.$http({
        url: this.$http.adornUrl("/course/stage/list"),
        method: "get",
        params: this.$http.adornParams({
          page: this.pageIndex,
          limit: this.pageSize,
          ...this.dataForm,
        }),
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataList = data.page.list;
          this.totalPage = data.page.totalCount;
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    doSearch() {
      let that = this;
      document.onkeypress = function (e) {
        let keycode = document.all ? event.keyCode : e.which;
        if (keycode == 13) {
          that.rgetDataList();
        }
      }
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 删除
    deleteHandle(row) {
      console.log(row);
      const { id, stageName } = row;
      this.$confirm(`确认删除${stageName}?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl("course/stage/delete"),
          method: "delete",
          data: id,
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getDataList();
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },
    onClickRow(row) {
      const i = this.dataList.findIndex((v) => v.id === row.id);
      console.log(i);
      this.dataList.splice(i, 1, {
        ...this.dataList[i],
        sortFlag: !this.dataList[i].sortFlag,
      });
    },
    onSortBlur(row) {
      console.log(row);
      this.$http({
        url: this.$http.adornUrl(`course/stage/update`),
        method: `put`,
        data: this.$http.adornData({
          ...row,
          sort: row.sort,
        }),
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.getDataList();
          this.$message({
            message: `更新成功`,
            type: "success",
          });
        } else {
          this.$message.error(data.msg);
        }
      });
      this.onClickRow(row);
    },
  },
};
</script>
